module.exports = __webpack_public_path__ + "static/contact-536eb482fd7cc3faa19853e7459b6c49.svg";